import React, {useEffect, useState} from 'react'
import '../../base/Theme.css';
import './Chat.css';
import ChatMessage from "./message/ChatMessage";
import Button from "../../base/button/Button";
import autosize from "autosize/dist/autosize";

const Chat = ({messages, onSendClick}) => {

    const [message, setMessage] = useState("");

    useEffect(() => {
        autosize(document.querySelectorAll('textarea'));
    }, [])

    const buildInput = () => {
        return <textarea
            className="MessageInput"
            placeholder="Message"
            value={message} rows={1}
            onKeyPress={onKeyPress}
            onChange={onMessageChanged}
        />
    }

    const buildMessages = () => {
        return messages?.map((m) => (
            <ChatMessage message={m}/>
        ));
    }

    const onMessageChanged = (event) => {
        let input = event.target.value;
        setMessage(input);
    }

    const onKeyPress = (event) => {
        if (event.charCode === 13 && !event.shiftKey) {
            sendMessage();
            event.preventDefault();
        }
    }

    const sendMessage = () => {
        const finalMessage = message.trimLeft().trimRight();
        if (finalMessage) {
            onSendClick(finalMessage);
            setMessage("");
        }
    }

    return (
        <div className="ChatRoot">
            <div className="NewMessage">
                {buildInput()}
                <Button style="PrimaryButton SendButton" text="Send" onClick={sendMessage}/>
            </div>
            <div className="ChatMessages">
                {buildMessages()}
            </div>
        </div>
    );
}

export default Chat;
